var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-list",
        [
          _c(
            "v-list-tile",
            [
              _c(
                "v-list-tile-action",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "accent", fab: "", small: "" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("open-timeline", _vm.settlementItem)
                        }
                      }
                    },
                    [_c("v-icon", { staticClass: "pa-2" }, [_vm._v("chat")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile-content",
                [_c("v-list-tile-title", [_vm._v("Settlement History")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-tile",
            [
              _c(
                "v-list-tile-action",
                [
                  _vm.showSettlementUpdateButton(_vm.settlementItem)
                    ? _c(
                        "v-update-settlement-btn",
                        {
                          attrs: {
                            small: "",
                            fab: "",
                            disabled: !!_vm.settlementItem.invoiceNumber,
                            settlement: _vm.settlementItem,
                            color: "accent"
                          },
                          on: {
                            refresh: function($event) {
                              return _vm.$emit("refresh")
                            }
                          }
                        },
                        [
                          _c(
                            "template",
                            { slot: "default" },
                            [
                              _c("v-icon", { attrs: { color: "white" } }, [
                                _vm._v("edit")
                              ])
                            ],
                            1
                          )
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile-content",
                { staticClass: "pl-2" },
                [
                  _c("V-list-tile-title", [
                    _vm._v("Update Settlement Details")
                  ]),
                  _vm._v(" "),
                  _c("v-list-tile-sub-title", [
                    _c(
                      "span",
                      { staticClass: "font-weight-light font-italic" },
                      [
                        _vm._v(
                          "\n            Adjust Amount, " +
                            _vm._s(_vm.$t("terms.bill-of-lading")) +
                            " Number, Head Count\n          "
                        )
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$vuetify.breakpoint.smAndDown
                ? _c(
                    "v-list-tile-action",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "pl-1 pr-1",
                          attrs: { flat: "", color: "accent" },
                          on: { click: _vm.requestRedoBillOfLading }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { column: "" } },
                            [
                              _c("v-icon", { staticClass: "pr-2" }, [
                                _vm._v("refresh")
                              ]),
                              _vm._v("\n            Redo BoL\n          ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-tile",
            { attrs: { avatar: "" } },
            [
              _c(
                "v-list-tile-action",
                [
                  _vm.shouldDisplayQuickbooksBillingButton
                    ? _c("v-quickbooks-billing-btn", {
                        attrs: {
                          disabled: _vm.disableQbButton,
                          loading: _vm.loading,
                          "invoicing-company": _vm.invoicingCompany,
                          settlement: _vm.settlementItem
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile-content",
                { staticClass: "pl-2" },
                [
                  _c("v-list-tile-title", [
                    _c("b", [_vm._v(_vm._s(_vm.invoice.paidTo.name))])
                  ]),
                  _vm._v(" "),
                  _c("v-list-tile-sub-title", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.settlementItem.description) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-list-tile-sub-title", [
                    _vm._v(
                      "\n        $" +
                        _vm._s(_vm.settlementItem.amount) +
                        "\n        "
                    ),
                    _c("span", { staticClass: "font-italic" }, [
                      _vm._v(
                        "\n                      billed to " +
                          _vm._s(_vm.invoice.billedTo.name) +
                          "\n      "
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$vuetify.breakpoint.smAndDown
                ? _c(
                    "v-list-tile-action",
                    [
                      _c(
                        "v-list-tile-action-text",
                        [
                          _vm._.get(_vm.settlementItem, "status", false)
                            ? _c(
                                "v-chip",
                                {
                                  attrs: {
                                    color: "primary",
                                    "text-color": "white",
                                    small: ""
                                  }
                                },
                                [
                                  _c(
                                    "v-avatar",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "pl-2",
                                          attrs: { color: "white" }
                                        },
                                        [
                                          _vm._v(
                                            "\n              receipt\n            "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm._.get(_vm.settlementItem, "status")
                                      ) +
                                      "\n        "
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.$vuetify.breakpoint.smAndDown
        ? _c(
            "v-card",
            [
              _c(
                "v-card-actions",
                [
                  _vm._.get(_vm.settlementItem, "status", false)
                    ? _c(
                        "v-chip",
                        {
                          attrs: {
                            color: "primary",
                            "text-color": "white",
                            small: ""
                          }
                        },
                        [
                          _c(
                            "v-avatar",
                            [
                              _c("v-icon", { attrs: { color: "white" } }, [
                                _vm._v("receipt")
                              ])
                            ],
                            1
                          ),
                          _vm._v(
                            "\n       " +
                              _vm._s(_vm._.get(_vm.settlementItem, "status")) +
                              "\n     "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "pl-1 pr-1",
                      attrs: { flat: "", color: "accent" },
                      on: { click: _vm.requestRedoBillOfLading }
                    },
                    [
                      _c("v-icon", { staticClass: "pr-2" }, [
                        _vm._v("refresh")
                      ]),
                      _vm._v("\n       Redo BoL\n     ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ff2e3d4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff2e3d4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/simple/SettlementCard.vue
// module id = null
// module chunks = 